import React from 'react'

const About = () => {
  return (
    <div>
      <h1>
      this is About</h1>
    </div>
  )
}

export default About
